import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Spacings, mediaQuery } from '@styles/index';
import P1 from '@base/P1/P1';

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin: ${Spacings.SPACING_6B} 0px;
  ${mediaQuery.uptoMobile} {
    margin: ${Spacings.SPACING_0B};
  }
`;

const BulletPoint = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${Spacings.SPACING_3B};
  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_0B};
  }
`;

const Bullet = styled.div`
  height: ${Spacings.SPACING_2B};
  width: ${Spacings.SPACING_2B};
  margin-right: ${Spacings.SPACING_2B};
  border-radius: ${Spacings.SPACING_1B};
  border-style: solid;
  border-width: 1px;
  background-color: ${({ $color }) => $color};
  border-color: ${({ $borderColor, $color }) => $borderColor || $color};
`;

const Summary = ({
  answeredLabel,
  answeredLabelColor,
  markedLabel,
  markedLabelColor,
  unansweredLabel,
  unansweredLabelColor
}) => {
  return (
    <Wrapper>
      <BulletPoint>
        <Bullet $color={answeredLabelColor ?? 'var(--color-i-green)'} />
        <P1>{answeredLabel}</P1>
      </BulletPoint>
      <BulletPoint>
        <Bullet $color={markedLabelColor ?? 'var(--color-i-orange-1)'} />
        <P1>{markedLabel}</P1>
      </BulletPoint>
      <BulletPoint>
        <Bullet
          $color={unansweredLabelColor ?? 'var(--color-base-1)'}
          $borderColor="var(--color-text-secondary)"
        />
        <P1>{unansweredLabel}</P1>
      </BulletPoint>
    </Wrapper>
  );
};

export default Summary;

Summary.propTypes = {
  answeredLabel: PropTypes.string.isRequired,
  markedLabel: PropTypes.string.isRequired,
  unansweredLabel: PropTypes.string.isRequired
};
